// extracted by mini-css-extract-plugin
export default {"switch":"Notifications_switch__x7I75","box":"Notifications_box__GkYZS"};